import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OpdScheduleManagerComponent } from 'app/masters/schedule-master/opd-schedule-manager/opd-schedule-manager.component';

@Component({
  selector: 'app-operation-type-master',
  templateUrl: './operation-type-master.component.html',
  styleUrls: ['./operation-type-master.component.scss']
})
export class OperationTypeMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  
  }

  openoperationModal(){
    document.getElementById("operationtypeModal").style.display='block'; 
  }

  closeoperationtypeModal(){
    document.getElementById("operationtypeModal").style.display='none';
  }

}
